import type { LevelData } from '../level/LevelData';
import type { LevelTaskProgress, LevelTaskTallies } from './types';
import { LevelTaskType } from './types';

export function convertTasksToProgress(levelData: LevelData): LevelTaskProgress[] {
  if (Array.isArray(levelData.goal)) {
    return levelData.goal.map((task) => ({
      type: task.type,
      collected: 0,
      goal: task.amount,
    }));
  }

  // Legacy format goal was a single value.
  return [
    {
      type: LevelTaskType.Hexes,
      collected: 0,
      goal: levelData.goal,
    },
  ];
}

export function mergeTaskTalliesWithProgress(
  taskTallies: LevelTaskTallies,
  tasksProgress: LevelTaskProgress[],
): LevelTaskProgress[] {
  return tasksProgress.map(({ collected, type, ...rest }) => ({
    type,
    collected: collected + (taskTallies[type] ?? 0),
    ...rest,
  }));
}

export function convertLevelScoreToTaskTallies(levelScore: number): LevelTaskTallies {
  return {
    [LevelTaskType.Hexes]: levelScore,
  };
}

export function hasTaskTally(taskTallies: LevelTaskTallies): boolean {
  return Object.values(taskTallies).some((tally) => tally > 0);
}

export function getCombinedTasksGoals(tasks: LevelTaskProgress[]): number {
  return tasks.reduce((acc, { goal }) => acc + goal, 0);
}

export function getCombinedTasksTally(tasks: LevelTaskProgress[]): number {
  return tasks.reduce((acc, task) => acc + Math.min(task.collected, task.goal), 0);
}
